export type EmailTemplateStateId =
  | 'PENDING_FORMALIZATION'
  | 'PENDING_VERIFICATION'
  | 'CONFIRMED'
  | 'ACTIVE'
  | 'CANCELLED'
  | 'COMPLETED'
  | 'MANUAL_BLOCK';

export type EmailTemplateDocId =
  | EmailTemplateStateId
  | 'PENDING_FORMALIZATION_OWNER'
  | 'PENDING_VERIFICATION_OWNER'
  | 'DEPOSIT_RECEIPT_REJECTED'
  | 'SECURITY_DEPOSIT_DUE'
  | 'FORMALIZATION_REMINDER'
  | 'FAST_TRACK_VERIFICATION'
  | 'FAST_TRACK_VERIFICATION_OWNER';

export interface EmailTemplateCatalogEntry {
  docId: EmailTemplateDocId;
  navLabel: string;
  audience: 'guest' | 'owner' | 'none';
}

export const EMAIL_TEMPLATE_CATALOG: EmailTemplateCatalogEntry[] = [
  { docId: 'PENDING_FORMALIZATION',       navLabel: 'Pendiente formalización',                  audience: 'guest' },
  { docId: 'PENDING_FORMALIZATION_OWNER', navLabel: 'Nueva reserva iniciada (propietario)',      audience: 'owner' },
  { docId: 'PENDING_VERIFICATION',        navLabel: 'Pendiente verificación',                   audience: 'guest' },
  { docId: 'PENDING_VERIFICATION_OWNER',  navLabel: 'Pendiente verificación (propietario)',      audience: 'owner' },
  { docId: 'DEPOSIT_RECEIPT_REJECTED',    navLabel: 'Justificante rechazado (cliente)',          audience: 'guest' },
  { docId: 'SECURITY_DEPOSIT_DUE',        navLabel: 'Fianza pendiente (T-48h)',                  audience: 'guest' },
  { docId: 'FORMALIZATION_REMINDER',      navLabel: 'Recordatorio formalización (<24h)',         audience: 'guest' },
  { docId: 'FAST_TRACK_VERIFICATION',     navLabel: 'Fast-track Bizum (cliente)',                audience: 'guest' },
  { docId: 'FAST_TRACK_VERIFICATION_OWNER', navLabel: 'Fast-track Bizum urgente (propietario)', audience: 'owner' },
  { docId: 'CONFIRMED', navLabel: 'Confirmada', audience: 'guest' },
  { docId: 'ACTIVE', navLabel: 'En curso', audience: 'guest' },
  { docId: 'CANCELLED', navLabel: 'Cancelada', audience: 'guest' },
  { docId: 'COMPLETED', navLabel: 'Completada', audience: 'guest' },
  { docId: 'MANUAL_BLOCK', navLabel: 'Bloqueo manual', audience: 'none' },
];

export const EMAIL_TEMPLATE_TOKEN_HINTS: { key: string; label: string }[] = [
  { key: 'userName', label: 'Nombre del cliente' },
  { key: 'userEmail', label: 'Email del cliente' },
  { key: 'ownerName', label: 'Nombre del propietario' },
  { key: 'ownerEmail', label: 'Email del propietario' },
  { key: 'guestName', label: 'Nombre del cliente (en correo al propietario)' },
  { key: 'spaceName', label: 'Nombre del espacio' },
  { key: 'bookingDate', label: 'Fecha del evento (legible)' },
  { key: 'bookingHours', label: 'Franja horaria' },
  { key: 'totalPrice', label: 'Precio total' },
  { key: 'payoutOwner', label: 'Señal al propietario (saldo directo)' },
  { key: 'onlineFee', label: 'Tasa de gestión online (importe cobrado)' },
  { key: 'formalizationUrl', label: 'Enlace a formalización' },
  { key: 'manageBookingsUrl', label: 'Enlace gestión reservas (propietario)' },
  { key: 'deadlineLabel', label: 'Fecha límite formalización' },
  { key: 'formalizationPlazo', label: 'Texto del plazo (7/3/1 días…)' },
  { key: 'rejectionNote', label: 'Motivo del rechazo del justificante (solo plantilla DEPOSIT_RECEIPT_REJECTED)' },
  { key: 'bookingId', label: 'ID de la reserva' },
  { key: 'reviewUrl', label: 'Enlace para dejar valoración (plantilla COMPLETED)' },
  { key: 'pendingFormalizationStep', label: 'Texto del paso pendiente (recordatorio <24h)' },
  { key: 'guestPhone', label: 'Teléfono móvil del cliente' },
];

export interface EmailTemplate {
  stateId: EmailTemplateDocId;
  label: string;
  description: string;
  enabled: boolean;
  audience: 'guest' | 'owner' | 'none';
  subject: string;
  bodyHtml: string;
  bodyText: string;
  supportedTokens: string[];
  updatedAt?: unknown;
  updatedBy?: string;
}
